export enum Icons {
    assignment = 'assignment',
    lockOpen = 'lock_open',
    thumbUp = 'thumb_up',
    thumbDown = 'thumb_down',
    report = 'report',
    copy = 'copy',
    info = 'info',
    help = 'help',
    message = 'message',
    check = 'check',
    clear = 'clear',
    schedule = 'schedule',
    moreTime = 'more_time',
    hourglassTop = 'hourglass_top',
    hourglassBottom = 'hourglass_bottom',
    hourglassEmpty = 'hourglass_empty',
    menu = 'menu',
    star = 'star',
    starOutline = 'star_border',
    storefront = 'storefront',
    add = 'add',
    remove = 'remove',
    edit = 'edit',
    stop = 'stop',
    start = 'start',
    delete = 'delete',
    arrowUpward = 'arrow_upward',
    zoomIn = 'zoom_in',
    zoomOut = 'zoom_out',
    zoomOutAll = 'zoom_out_map',
    hideImage = 'hide_image',
    link = 'link',
    dragIndicator = 'drag_indicator',
    dragHandle = 'drag_handle',
    arrowBack = 'arrow_back',
    arrowForward = 'arrow_forward',
    pdf = 'picture_as_pdf',
    warning = 'warning',
    download = 'download',
    fileDownload = 'file_download',
    chevronRight = 'chevron_right',
    chevronLeft = 'chevron_left',
    chevronDown = 'keyboard_arrow_down',
    chevronUp = 'keyboard_arrow_up',
    keyboardExternalInput = 'keyboard_external_input',
    refresh = 'refresh',
    openInNewWindow = 'open_in_new',
    'new-tab' = 'open_in_new',
    emptyCheckbox = 'check_box_outline_blank',
    checkbox = 'check_box',
    emptyRadio = 'radio_button_unchecked',
    radio = 'radio_button_checked',
    play = 'play_arrow',
    pause = 'pause',
    send = 'send',
    mute = 'volume_off',
    unmute = 'volume_up',
    uploadDocument = 'note_add',
    visibility = 'visibility',
    upload = 'upload',
    appRegistration = 'app_registration',
    adminPanelSettings = 'admin_panel_settings',
    settings = 'settings',
    api = 'api',
    modelTraining = 'model_training',
    hub = 'hub',
    accountCircle = 'account_circle',
    image = 'image',
    save = 'save',
    person = 'person',
    group = 'group',
    medal = 'military_tech',
    account = 'manage_accounts',
    badge = 'badge',
    search = 'search',
    searchOff = 'search_off',
    shoppingCart = 'shopping_cart',
    sortDefault = 'swap_vert',
    sortAsc = 'vertical_align_top',
    sortDesc = 'vertical_align_bottom',
    promptGallery = 'view_cozy',
    filterReset = 'filter_alt_off',
    promptSuggestion = 'notes',
    promptSave = 'library_add',
    light = 'light',
    wand = 'auto_fix_high',
    grid = 'grid_on',
    create = 'create'
}
